import { useTranslation } from 'react-i18next';
import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



export const GridError = () => {
	const { t } = useTranslation('global');

	return (
		<div className="app-grid-cell row-cell">
			<p>{t('loadingErrorMessage')}</p>
		</div>
	)
}


export const GridEmpty = () => {
	const { t } = useTranslation('global');

	return (
		<div className="app-grid-cell row-cell">
			<p>{t('pages.noRecords')}</p>
		</div>
	)
}


export const GridLoading = () => {

	return (
		<div className="app-grid-cell row-cell">
			<LoadingSpinner />
		</div>
	)
}